import Joi from 'joi-browser';
import { compose, withState, withHandlers } from 'react-recompose';

const reduceErrors = field => (prev, next) => {
	if (prev[field] && field === next.context.key) {
		return prev;
	}
	return {
		...prev,
		[next.context.key]: next.message,
	};
};

export default (joiSchema, onValid, state = 'state') => baseComponent => {
	const validationHandlers = {
		validateHandler: props => stateField => () => {
			const options = {
				allowUnknown: true,
				presence: 'optional',
				abortEarly: false,
			};

			Joi.validate(props[state], joiSchema, options, err => {
				if (err) {
					props.setErrors(prevErr => err.details.reduce(reduceErrors(stateField), prevErr));
				} else {
					props.setErrors(prevErr => ({
						...prevErr,
						[stateField]: undefined,
					}));
				}
			});
		},
		validateAllHandler: props => () => {
			const options = {
				allowUnknown: true,
				presence: 'required',
			};

			Joi.validate(props[state], joiSchema, options, err => {
				if (!err) {
					return onValid(props);
				}
				props.setErrors(() => err.details.reduce(reduceErrors(), {}));
			});
		},
	};

	return compose(
		withState('errors', 'setErrors', {}),
		withHandlers(validationHandlers),
	)(baseComponent);
};
